import React from "react";
import PageBase from "../components/PageBase";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { grey500 } from "material-ui/styles/colors";
import Divider from "material-ui/Divider";
import { Helmet } from "react-helmet";

const Benjaminak = () => {
  const styles = {
    floatingActionButton: {
      margin: 0,
      top: "auto",
      right: 20,
      bottom: 20,
      left: "auto",
      position: "fixed",
    },
    images: {
      maxWidth: "100%",
    },
    editButton: {
      fill: grey500,
    },
    filas: {
      textAlign: "left",
    },
  };

  return (
    <PageBase
      title="Benjaminak"
      navigation="Oñatiko Duatloi Txikia / Benjaminak"
    >
      <Helmet>
        <title>Oñatiko Dutloi Txikia Benjaminak</title>
        <meta
          name="description"
          content="Oñatiko duatloi txikiko benjamin kategoriako zirkuituak"
        />
        <meta property="og:title" content="Oñatiko Dutloi Txikia Benjaminak" />
        <meta
          property="og:description"
          content="Oñatiko duatloi txikiko benjamin kategoriako zirkuituak"
        />
        <meta
          property="og:url"
          content="http://duatloitxikia.oinatikoduatloia.com/benjaminak"
        />
        <meta
          property="og:image"
          content="http://duatloitxikia.oinatikoduatloia.com/benjaminT1.png"
        />
      </Helmet>

      <Table>
        <Thead>
          <Tr>
            <Th style={styles.filas}>Ordua</Th>
            <Th style={styles.filas}>Sektorea</Th>
            <Th style={styles.filas}>Itzuli Kopurua</Th>
            <Th style={styles.filas}>Distantzia</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>11:00</Td>
            <Td>Korrika 1</Td>
            <Td>Itzuli 1 + zati bat (elkarrekin)</Td>
            <Td>500m</Td>
          </Tr>
          <Tr>
            <Td />
            <Td>Bizikleta</Td>
            <Td>Itzuli 1 (elkarrekin)</Td>
            <Td>1500m</Td>
          </Tr>
          <Tr>
            <Td />
            <Td>Korrika 2</Td>
            <Td>Itzuli 1</Td>
            <Td>500m</Td>
          </Tr>
        </Tbody>
      </Table>

      <Divider />

      <div className="row">
        <div className="col-md-12">
          <h3>Korrika 1</h3>
          <center>
            <img
              src={require("../images/benjamin-korrika-1.png")}
              style={styles.images}
            />
          </center>

          <h3>Bizikleta</h3>
          <center>
            <img
              src={require("../images/benjaminT2.png")}
              style={styles.images}
            />
          </center>

          <h3>Korrika 2</h3>
          <center>
            <img
              src={require("../images/benjamin-korrika-2.png")}
              style={styles.images}
            />
          </center>
        </div>
      </div>
    </PageBase>
  );
};

export default Benjaminak;



/** WEBPACK FOOTER **
 ** ./src/containers/Benjaminak.js
 **/